package com.shadowings.gero.presentation.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.shadowings.gero.domain.model.FeaturePollOption
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.domain.repository.AnalyticsRepository
import com.shadowings.gero.domain.repository.UserDataRepository
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch

class FeaturePollViewModel(
    private val userDataRepository: UserDataRepository,
    private val analyticsRepository: AnalyticsRepository,
) : ViewModel() {

    val userData: StateFlow<UserData> = userDataRepository.userData
        .stateIn(viewModelScope, SharingStarted.Eagerly, UserData())

    fun submit(option: FeaturePollOption, freeText: String) {
        viewModelScope.launch(Dispatchers.Default) {
            userDataRepository.setFeaturePollAnswered(FeaturePollOption.POLL_KEY, true)
            analyticsRepository.logFeaturePollResponse(option.analyticsKey, freeText)
        }
    }
}
